import Box from '@mui/material/Box';

const styles = {
  root: {
    '& dl': {
      '& dd': {
        '&:after': {
          content: '"\\a"',
          whiteSpace: 'pre',
        },
        color: 'secondary.main',
        display: 'inline',
        m: 0,
      },
      '& dt': {
        '&:first-of-type': {
          mt: 0,
        },
        color: 'primary.main',
        display: 'inline-block',
        fontWeight: 'bold',
        mt: 0.25,
      },
    },
    listStyle: 'none',
    m: 0,
    p: 0,
  },
};

export interface IGTCDescription {
  html: string;
}

export function GTCDescription({ html }: IGTCDescription) {
  return <Box dangerouslySetInnerHTML={{ __html: html }} sx={styles.root} />;
}
